export default "__VITE_ASSET__CEVthPBQ__"